const APP_VOLUME_DECIMAL_PLACES = 8;

export function formatAppVolume(value) {
  if (value == null || value === "") {
    return "Brak Danych";
  }

  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) {
    return "Brak Danych";
  }

  const multiplier = 10 ** APP_VOLUME_DECIMAL_PLACES;
  const sign = numericValue < 0 ? -1 : 1;
  const roundedValue =
    (sign *
      Math.round((Math.abs(numericValue) + Number.EPSILON) * multiplier)) /
    multiplier;

  if (Object.is(roundedValue, -0) || roundedValue === 0) {
    return "0";
  }

  return roundedValue
    .toFixed(APP_VOLUME_DECIMAL_PLACES)
    .replace(/\.?0+$/, "");
}
